import React, { useState } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "./Firebase";
import styled from "styled-components";
import { FormGroup, ContenedorFormBase } from "./CostCalculadora";
import { useData } from "./DataContext";
import { Alert, CloseButton } from "./App";
import { RiUploadCloud2Fill } from "react-icons/ri";

const LineaDiv = styled.div`
  margin: 5px 0px 5px 0px;
  width: 100%;
  height: 0.5px;
  background-color: #c20000;
`;
const ContenedorDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: auto;
  margin-bottom: 4rem;
  width: 350px;
  align-content: center;
`;

const DataEntryForm = () => {
  /*///////////////dataContext/////////////////////////*/
  const {
    sueldoData,
    viaticosNacionalesData,
    fechaData,
    viaticosInternacionalesData,
    baseData,
    tasaData,
    peajeData,
    viaticoData,
    costoUnidadesData,
  } = useData();
  const viaticoProvincial = viaticoData[0]?.viatico;
  const fechaActualizacion = fechaData[0]?.fecha;
  const precioTasa = tasaData[0]?.tasa;
  const precioPeaje = peajeData[0]?.peaje;
  const btm = baseData[0]?.base;
  const sueldoChofer = sueldoData[0]?.sueldo;
  const {
    almuerzo: almuerzoNacional,
    cama: camaNacional,
    cena: cenaNacional,
    desayuno: desayunoNacional,
    merienda: meriendaNacional,
  } = viaticosNacionalesData[0] || {};
  const {
    almuerzo: almuerzoInternacional,
    cama: camaInternacional,
    cena: cenaInternacional,
    desayuno: desayunoInternacional,
    merienda: meriendaInternacional,
  } = viaticosInternacionalesData[0] || {};
  const {
    costoBusDoble: costoBusDobleData,
    costoBus40: costoBus40Data,
    costoVan19: costoVan19Data,
  } = costoUnidadesData[0] || {};

  /*////////////////////////////////////////*/

  const [fecha, setFecha] = useState("");
  const [sueldo, setSueldo] = useState("");
  const [peaje, setPeaje] = useState("");
  const [base, setBase] = useState("");
  const [viatico, setViatico] = useState("");
  const [almuerzo, setAlmuerzo] = useState("");
  const [cama, setCama] = useState("");
  const [cena, setCena] = useState("");
  const [desayuno, setDesayuno] = useState("");
  const [merienda, setMerienda] = useState("");
  const [tasa, setTasa] = useState("");
  const [costoBusDoble, setCostoBusDoble] = useState("");
  const [costoBus40, setCostoBus40] = useState("");
  const [costoVan19, setCostoVan19] = useState("");
  const [showAlertDatos, setShowAlertDatos] = useState(false);
  const [showAlertError, setShowAlertError] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const closeAlert = () => {
    setShowAlertDatos(false);
    setShowAlertError(false);
    setShowAlert(false);
  };

  const handleFechaSubmit = async (e) => {
    e.preventDefault();
    if (!fecha) {
      setShowAlert(true);
      return;
    }
    try {
      const fechaRef = doc(
        db,
        "fechaActualizacionCostos",
        "8isZJuwp1XXrItjcSTdB"
      );
      await updateDoc(fechaRef, {
        fecha,
      });
      setFecha("");
      setShowAlertDatos(true);
    } catch (error) {
      setShowAlertError(true);
    }
  };

  const handleTasaSubmit = async (e) => {
    e.preventDefault();
    if (!tasa) {
      setShowAlert(true);
      return;
    }
    try {
      const tasaEmbarqueRef = doc(db, "TasaEmbarque", "i8CHWTM1fXU67FZhpPCQ");
      await updateDoc(tasaEmbarqueRef, {
        tasa: parseFloat(tasa),
      });
      setTasa("");
      setShowAlertDatos(true);
    } catch (error) {
      setShowAlertError(true);
    }
  };

  const handlePeajeSubmit = async (e) => {
    e.preventDefault();
    if (!setPeaje) {
      setShowAlert(true);
      return;
    }
    try {
      const peajeRef = doc(db, "peajes", "GBEaaQyrzsgmgbwscpYX");
      const nuevoValor = peaje * 1055 * 1.25; // Calcula el nuevo valor por los kilometros mza / CABA * 25% (diferencia entre camion y bus larga distancia)
      const valorRedondeado = Math.round(nuevoValor); // Redondea el valor
      await updateDoc(peajeRef, {
        peaje: parseFloat(valorRedondeado), // Guarda el valor redondeado en la base de datos
      });

      setPeaje("");
      setShowAlertDatos(true);
    } catch (error) {
      setShowAlertError(true);
    }
  };

  const handleSueldoSubmit = async (e) => {
    e.preventDefault();
    if (!sueldo) {
      setShowAlert(true);
      return;
    }
    try {
      const sueldoChoferRef = doc(db, "sueldoChofer", "yLdTds9JU7YNnsRjz5HG");
      await updateDoc(sueldoChoferRef, {
        sueldo: parseFloat(sueldo),
      });
      setSueldo("");
      setShowAlertDatos(true);
    } catch (error) {
      setShowAlertError(true);
    }
  };

  const handleViaticoProvincialSubmit = async (e) => {
    e.preventDefault();
    if (!viatico) {
      setShowAlert(true);
      return;
    }
    try {
      const viaticoProvincialRef = doc(
        db,
        "viaticoProvincial",
        "E2B535ghfj173vCpWwNX"
      );
      await updateDoc(viaticoProvincialRef, {
        viatico: parseFloat(viatico),
      });
      setViatico("");
      setShowAlertDatos(true);
    } catch (error) {
      setShowAlertError(true);
    }
  };

  const handleViaticosInternacionalesSubmit = async (e) => {
    e.preventDefault();
    if (!almuerzo || !cama || !cena || !desayuno || !merienda) {
      setShowAlert(true);
      return;
    }
    try {
      const viaticosInternacionalesRef = doc(
        db,
        "viaticosInternacionales",
        "FGP4V0cFKmDTDTd8fYE9"
      );
      await updateDoc(viaticosInternacionalesRef, {
        almuerzo: parseFloat(almuerzo),
        cama: parseFloat(cama),
        cena: parseFloat(cena),
        desayuno: parseFloat(desayuno),
        merienda: parseFloat(merienda),
      });
      setAlmuerzo("");
      setCama("");
      setCena("");
      setDesayuno("");
      setMerienda("");
      setShowAlertDatos(true);
    } catch (error) {
      setShowAlertError(true);
    }
  };

  const handleViaticosNacionalesSubmit = async (e) => {
    e.preventDefault();
    if (!almuerzo || !cama || !cena || !desayuno || !merienda) {
      setShowAlert(true);
      return;
    }
    try {
      const viaticosNacionalesRef = doc(
        db,
        "viaticosNacionales",
        "l9GkL2Cf8t3kkjpyrrcR"
      );
      await updateDoc(viaticosNacionalesRef, {
        almuerzo: parseFloat(almuerzo),
        cama: parseFloat(cama),
        cena: parseFloat(cena),
        desayuno: parseFloat(desayuno),
        merienda: parseFloat(merienda),
      });
      setAlmuerzo("");
      setCama("");
      setCena("");
      setDesayuno("");
      setMerienda("");
      setShowAlertDatos(true);
    } catch (error) {
      setShowAlertError(true);
    }
  };
  //sube costo BusDoble y btm
  const handleBusDobleSubmit = async (e) => {
    e.preventDefault();
    if (!costoBusDoble) {
      setShowAlert(true);
      return;
    }

    try {
      const busDobleRef = doc(db, "costoUnidades", "kpChqhkPNdPxAISMBYb5");
      await updateDoc(busDobleRef, {
        costoBusDoble: parseFloat(costoBusDoble),
      });

      const btmRef = doc(db, "btm", "I3V0yPsHLeF3MtpHktz2");
      await updateDoc(btmRef, {
        base: parseFloat(base),
      });
      setCostoBusDoble("");
      setBase("");
      setShowAlertDatos(true);
    } catch (error) {
      setShowAlertError(true);
    }
  };

  //Bus40
  const handleBus40Submit = async (e) => {
    e.preventDefault();
    if (!costoBus40) {
      setShowAlert(true);
      return;
    }
    try {
      const bus40Ref = doc(db, "costoUnidades", "kpChqhkPNdPxAISMBYb5");
      await updateDoc(bus40Ref, {
        costoBus40: parseFloat(costoBus40),
      });
      setCostoBus40("");
      setShowAlertDatos(true);
    } catch (error) {
      setShowAlertError(true);
    }
  };

  //Van19
  const handleVan19Submit = async (e) => {
    e.preventDefault();
    if (!costoVan19) {
      setShowAlert(true);
      return;
    }
  
    try {
      const van19Ref = doc(db, "costoUnidades", "kpChqhkPNdPxAISMBYb5");
  
      // Calcular el costoMiniBus sin decimales
      const costoMiniBus = Math.round(parseFloat(costoVan19) * 1.05);
  
      await updateDoc(van19Ref, {
        costoVan19: parseFloat(costoVan19),
        costoMiniBus, // Subir el nuevo campo costoMiniBus
      });
  
      setCostoVan19("");
      setShowAlertDatos(true);
    } catch (error) {
      setShowAlertError(true);
    }
  };
  

  return (
    <ContenedorDiv>
      {showAlert && (
        <Alert>
          <CloseButton onClick={closeAlert}>&times;</CloseButton>
          Por favor, complete los campos vacios.
        </Alert>
      )}
      {showAlertDatos && (
        <Alert>
          <CloseButton onClick={closeAlert}>&times;</CloseButton>
          Datos guardados con éxito.
        </Alert>
      )}
      {showAlertError && (
        <Alert>
          <CloseButton onClick={closeAlert}>&times;</CloseButton>
          Error al guardar los datos.
        </Alert>
      )}
      <h4>Actulización de costos</h4>
      <p>
        Ultima actualización{" "}
        {new Date(
          new Date(fechaActualizacion).toLocaleString("en-US", {
            timeZone: "UTC",
          })
        ).toLocaleDateString("es-ES")}
      </p>
      <ContenedorFormBase>
        <LineaDiv></LineaDiv>
        <FormGroup>
          <label>Tasa de embarque:</label>
          <input
            type="number"
            placeholder={`$${precioTasa}`}
            value={tasa}
            onChange={(e) => setTasa(e.target.value)}
          />
        </FormGroup>
        <RiUploadCloud2Fill
          size={25}
          style={{ cursor: "pointer", marginLeft: 20 }}
          onClick={handleTasaSubmit}
        />
        <LineaDiv></LineaDiv>
        <FormGroup>
          <label>Peaje Fedeeac $xkm:</label>
          <input
            type="number"
            placeholder={`$${precioPeaje}`}
            value={peaje}
            onChange={(e) => setPeaje(e.target.value)}
          />
        </FormGroup>
        <RiUploadCloud2Fill
          size={25}
          style={{ cursor: "pointer", marginLeft: 20 }}
          onClick={handlePeajeSubmit}
        />
        <LineaDiv></LineaDiv>
        <FormGroup>
          <label>Sueldo Chofer:</label>
          <input
            type="number"
            placeholder={`$${sueldoChofer}`}
            value={sueldo}
            onChange={(e) => setSueldo(e.target.value)}
          />
        </FormGroup>
        <RiUploadCloud2Fill
          size={25}
          style={{ cursor: "pointer", marginLeft: 20 }}
          onClick={handleSueldoSubmit}
        />
        <LineaDiv></LineaDiv>
        <FormGroup>
          <label>Viáticos Provincial:</label>
          <input
            type="number"
            placeholder={`$${viaticoProvincial}`}
            value={viatico}
            onChange={(e) => setViatico(e.target.value)}
          />
        </FormGroup>
        <RiUploadCloud2Fill
          size={25}
          style={{ cursor: "pointer", marginLeft: 20 }}
          onClick={handleViaticoProvincialSubmit}
        />
        <LineaDiv></LineaDiv>
        <h5>Viáticos</h5>
        <FormGroup>
          <label>Desayuno:</label>
          <input
            type="number"
            placeholder={`Nac. $${desayunoNacional} Inter. $${desayunoInternacional}`}
            value={desayuno}
            onChange={(e) => setDesayuno(e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <label>Almuerzo:</label>
          <input
            type="number"
            placeholder={`Nac. $${almuerzoNacional} Inter. $${almuerzoInternacional}`}
            value={almuerzo}
            onChange={(e) => setAlmuerzo(e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <label>Merienda:</label>
          <input
            type="number"
            placeholder={`Nac. $${meriendaNacional} Inter. $${meriendaInternacional}`}
            value={merienda}
            onChange={(e) => setMerienda(e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <label>Cena:</label>
          <input
            type="number"
            placeholder={`Nac. $${cenaNacional} Inter. $${cenaInternacional}`}
            value={cena}
            onChange={(e) => setCena(e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <label>Cama:</label>
          <input
            type="number"
            placeholder={`Nac. $${camaNacional} Inter. $${camaInternacional}`}
            value={cama}
            onChange={(e) => setCama(e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <p style={{ marginTop: 10 }}>
            Nacional
            <RiUploadCloud2Fill
              size={25}
              style={{ cursor: "pointer", marginLeft: 10 }}
              onClick={handleViaticosNacionalesSubmit}
            />
          </p>
          <p style={{ marginTop: 10 }}>
            Internacional
            <RiUploadCloud2Fill
              size={25}
              style={{ cursor: "pointer", marginLeft: 10 }}
              onClick={handleViaticosInternacionalesSubmit}
            />
          </p>
        </FormGroup>
        <LineaDiv></LineaDiv>
        <FormGroup>
          <label>Costo Bus Doble:</label>
          <input
            type="number"
            placeholder={`$${costoBusDobleData} y BTM $${btm}`}
            value={costoBusDoble}
            onChange={(e) => {
              setCostoBusDoble(e.target.value);
              setBase((parseFloat(e.target.value) / 60).toFixed(2));}}
          />
        </FormGroup>
        <RiUploadCloud2Fill
          size={25}
          style={{ cursor: "pointer", marginLeft: 20 }}
          onClick={handleBusDobleSubmit}
        />
        <LineaDiv></LineaDiv>
        <FormGroup>
          <label>Costo Bus40:</label>
          <input
            type="number"
            placeholder={`$${costoBus40Data}`}
            value={costoBus40}
            onChange={(e) => setCostoBus40(e.target.value)}
          />
        </FormGroup>
        <RiUploadCloud2Fill
          size={25}
          style={{ cursor: "pointer", marginLeft: 20 }}
          onClick={handleBus40Submit}
        />
        <LineaDiv></LineaDiv>
        <FormGroup>
          <label>Costo Van19:</label>
          <input
            type="number"
            placeholder={`$${costoVan19Data}`}
            value={costoVan19}
            onChange={(e) => setCostoVan19(e.target.value)}
          />
        </FormGroup>
        <RiUploadCloud2Fill
          size={25}
          style={{ cursor: "pointer", marginLeft: 20 }}
          onClick={handleVan19Submit}
        />
        <LineaDiv></LineaDiv>
        <FormGroup>
          <label>Fecha actualización:</label>
          <input
            type="date"
            value={fecha}
            onChange={(e) => setFecha(e.target.value)}
          />
        </FormGroup>
        <RiUploadCloud2Fill
          size={25}
          style={{ cursor: "pointer", marginLeft: 20 }}
          onClick={handleFechaSubmit}
        />
      </ContenedorFormBase>
    </ContenedorDiv>
  );
};

export default DataEntryForm;
